import TopHeader from "./topheader.js";
import Footer from './footer.js';

export default function Careers() {
    return (
        <>
            <TopHeader MenuLevel="Careers" />
            <Footer />
        </>
    )
}